
import { ReportMenusModel, RolePermissionModel, UserModel } from '@app/domain/UserModel';

export const persistToken = (token: string): void => {
  localStorage.setItem('accessToken', token);
};

export const readToken = (): string => {
  return localStorage.getItem('accessToken') || '';
};


export const persistUser = (user: UserModel): void => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const readUser = (): UserModel | null => {
  const userStr = localStorage.getItem('user');

  return userStr ? JSON.parse(userStr) : null;
};

export const persistPermission = (permission: RolePermissionModel[]): void => {
  localStorage.setItem('permission', JSON.stringify(permission));
}

export const readPermission = (): RolePermissionModel[] | null => {
  const permissionStr = localStorage.getItem('permission');

  return permissionStr ? JSON.parse(permissionStr) : null;
}

export const persistReportMenus = (reportMenus: ReportMenusModel[]): void => {
  localStorage.setItem('reportMenus', JSON.stringify(reportMenus));
}

export const readReportMenus = (): ReportMenusModel[] | null => {
  const reportMenuStr = localStorage.getItem('reportMenus');

  return reportMenuStr ? JSON.parse(reportMenuStr) : null;
}

export const persistExpiryDate = (expiryDate: Date): void => {
  localStorage.setItem('expiryDate', expiryDate.toString());
}

export const readExpiryDate = (): Date | null => {
  const expiryDateStr = localStorage.getItem('expiryDate');

  return expiryDateStr ? new Date(parseInt(expiryDateStr)* 1000) : null;
}

export const deleteToken = (): void => localStorage.removeItem('accessToken');
export const deleteUser = (): void => localStorage.removeItem('user');
export const deletePermission = (): void => localStorage.removeItem('permission');
export const deleteReportMenus = (): void => localStorage.removeItem('reportMenus');
export const deleteExpiryDate = (): void => localStorage.removeItem('expiryDate');